import { EmptyState } from "@esp/ui";
import { Link } from "react-router";

export function NotFound() {
  return <EmptyState title="Page not found" action={<Link className="text-brand-700 underline" to="/">Overview</Link>} />;
}
